import {defaultResponseHandler, IMutationOptions, IQueryOptions, QueryKey, useQueryWrapper} from "./api-hooks-common";
import {MigrationsApi} from "../MigrationsApi";

import {useMutation, useQueryClient} from "@tanstack/react-query";

export const useGetMigrationTypes = () =>
    useQueryWrapper(
        [QueryKey.MIGRATIONS, "types"],
        () => MigrationsApi.getMigrations(),
        null,
        undefined,
    );

export const useGetMigrationActions = (migrationId: string, options?: IQueryOptions) =>
    useQueryWrapper(
        [QueryKey.MIGRATIONS, migrationId, "actions"],
        () => MigrationsApi.getMigrationActions(migrationId),
        null,
        options,
    );

export const useGetActionJobTimes = (
    migration: string,
    action: string,
    options?: IQueryOptions
) => useQueryWrapper(
    [QueryKey.MIGRATIONS, migration, action, "job", "times"],
    () => MigrationsApi.getActionJobTimes(migration, action),
    null,
    options,
);

export const useGetActionJobInfo = (
    migration: string,
    action: string,
    timestamp: string,
    options?: IQueryOptions
) => useQueryWrapper(
        [QueryKey.MIGRATIONS, migration, action, timestamp, "job"],
        () => MigrationsApi.getActionJobInfo(migration, action, timestamp),
        null,
        options,
    );

export const useRunMigrationActionMutation = (
    options?: IMutationOptions
) => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async (params: { migration: string, action: string, data?: Record<string, string | null> }) => {
            const res = await MigrationsApi.runMigrationAction(params);
            return defaultResponseHandler(res);
        },
        mutationKey: [QueryKey.MIGRATIONS, "run"],
        onSuccess: (data) => {
            const queryKey = [QueryKey.MIGRATIONS];
            queryClient.invalidateQueries({queryKey: queryKey});
            options?.onSuccess?.(data)
        },
        onMutate: (data) =>  options?.onMutate?.(data),
    });
}


